import styled from 'glamorous'
import map from 'lodash/map'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { $ } from 'utils'
import { Loader } from 'components'

import TokenListItem from './TokenListItem'

const Container = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflow: 'auto'
}, 'lists-scrollable')

const TokensList = ({
  tokens,
  loading
}) =>
  loading
    ? $(Loader)
    : $(Container,
        map(tokens, (token) => $(TokenListItem, { key: token.uuid, token })))

export default TokensList



// WEBPACK FOOTER //
// ./src/pages/Tokens/TokensList.js